import React from 'react'

import ResetButton from './ResetButton'
import SetPredictionModel from './SetPredictionModel'

class SettingsScreen extends React.Component<{}> {
  public render(): JSX.Element {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col">
            <SetPredictionModel />
          </div>
        </div>
        <div className="dropdown-divider"></div>
        <ResetButton />
      </React.Fragment>
    )
  }
}

export default SettingsScreen
